const ComplianceState = {
  Ask: "compliance-ask",
  NotAccepted: "compliance-not-accepted",
  Accepted: "compliance-accepted",
  Off: "compliance-off",
};

export default ComplianceState;
